<template>
  <div>
    <div v-title data-title="安丘专技教育-登录"></div>
    <phone-login-layout>
      <van-tabs v-model="active" class="border-0 position-relative login_tabs">
        <van-tab title="密码登录">
          <login-form-component type="password-login" ref="parentTab1"></login-form-component>
        </van-tab>
        <van-tab title="验证码登录">
          <login-form-component type="code-login" ref="parentTab2"></login-form-component>
        </van-tab>
        <!--<div class="w-100 anthor-login position-absolute">-->
        <!--<div class="d-flex justify-content-between align-items-center">-->
        <!--<a class="d-flex align-items-center" href="#">-->
        <!--<svg t="1590972658399" class="icon mr-1" viewBox="0 0 1024 1024" version="1.1"-->
        <!--xmlns="http://www.w3.org/2000/svg" p-id="5864" width="32" height="32">-->
        <!--<path-->
        <!--d="M629.077333 397.141333c3.669333 0 7.253333 0.042667 10.837334 0.213334C620.928 293.418667 514.218667 213.802667 385.450667 213.802667 243.2 213.76 128 310.826667 128 430.506667c0 70.144 39.594667 132.565333 101.034667 172.16l2.389333 1.493333L206.506667 682.666667 299.605333 634.88l4.394667 1.28a301.952 301.952 0 0 0 98.730667 10.496 169.088 169.088 0 0 1-8.149334-51.712c0-109.226667 105.002667-197.845333 234.496-197.845333z m-154.026666-76.501333c19.968 0 36.096 15.786667 36.096 35.242667a35.669333 35.669333 0 0 1-36.096 35.242666 35.712 35.712 0 0 1-36.181334-35.242666c0-19.456 16.213333-35.242667 36.181334-35.242667z m-179.2 70.485333a35.712 35.712 0 0 1-36.138667-35.242666c0-19.456 16.213333-35.242667 36.138667-35.242667 20.010667 0 36.181333 15.786667 36.181333 35.242667 0 19.456-16.213333 35.242667-36.181333 35.242666z"-->
        <!--fill="#538F0E" p-id="5865"></path>-->
        <!--<path-->
        <!--d="M426.666667 604.16c0 98.048 105.088 177.493333 234.666666 177.493333 25.984 0 50.944-3.157333 74.24-9.045333l4.010667-1.066667 84.821333 39.125334-22.656-64.256 2.133334-1.237334C859.861333 712.746667 896 661.674667 896 604.16c0-98.048-105.045333-177.493333-234.666667-177.493333-129.578667 0-234.666667 79.445333-234.666666 177.493333z m283.392-61.141333c0-15.914667 14.72-28.842667 32.938666-28.842667 18.218667 0 32.938667 12.928 32.938667 28.842667 0 15.957333-14.72 28.885333-32.938667 28.885333-18.218667 0-32.938667-12.928-32.938666-28.885333z m-163.328 0c0-15.914667 14.762667-28.842667 32.938666-28.842667 18.218667 0 32.981333 12.928 32.981334 28.842667 0 15.957333-14.762667 28.885333-32.981334 28.885333-18.176 0-32.938667-12.928-32.938666-28.885333z"-->
        <!--fill="#538F0E" p-id="5866"></path>-->
        <!--</svg>-->
        <!--使用微信登录</a>-->
        <!--<a class="d-flex align-items-center" href="#">-->
        <!--<img class="ql-icon mr-1" src="/static/img/index/logo1.png" alt="">-->
        <!--使用省网登录</a>-->
        <!--</div>-->
        <!--</div>-->
      </van-tabs>

    </phone-login-layout>

  </div>
</template>

<script>
import Vue from 'vue';
import { Form } from 'vant';
import { Field } from 'vant';
import { Tab, Tabs } from 'vant';
import PhoneLoginLayout from '@/page/login/components/phoneLoginLayout';
import LoginFormComponent from '@/page/login/components/loginFormComponent';


Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Form);

export default {
  name: 'phoneLogin',
  data() {
    return {
      active: 0,
    };
  },
  components: {
    LoginFormComponent,
    PhoneLoginLayout
  },
  methods: {},
  watch: {
    active: function (newVal, oldVal) {
      this.$nextTick(() => {
        $(this.$refs.parentTab1.$refs.loginForm.$el).find('.van-field__control').val('');
        $(this.$refs.parentTab1.$refs.loginForm.$el).find('.van-field__label').removeClass('inputTextFocus');
        this.$refs.parentTab1.$refs.loginForm.resetValidation();

        $(this.$refs.parentTab2.$refs.loginForm.$el).find('.van-field__control').val('');
        $(this.$refs.parentTab2.$refs.loginForm.$el).find('.van-field__label').removeClass('inputTextFocus');
        this.$refs.parentTab2.$refs.loginForm.resetValidation();
      });

    }
  }
};
</script>

<style>

</style>
